import api from "../../../store/AuthHeader";

const getDiaryCount = () => {
    return api.get(`/Diary/GetDiaryCount`);
};

const getDiaryActiveView = () => {
    return api.get(`/Diary/GetDiaryActiveView`);
};

const getAllEmployersForDiary = () => {
    return api.get("/Diary/GetAllEmployersForDiary");
};

const getDiaryActivitesByMemberEmployers = (employerids: any, currentDiaryDate: any) => {
    //Building the model to get diary activiteis based on current diary date
    let payload: any = {};
    payload.memberEmployerIds = employerids;
    payload.currentDiaryDate = currentDiaryDate;
    return api.post(`/Diary/GetDiaryActivitesByMemberEmployers`, payload);
};

const getAllWorkActivitiesForDiary = (subRoleId: number) => {
    return api.get(`/Diary/GetAllWorkActivitiesForDiary/${subRoleId}`);
};

const addDiaryActivities = (payload: any) => {
    return api.post("/Diary/AddDiaryActivities", payload);
};

const saveDiaryActiveView = (payload: any) => {
    return api.post("/Diary/SaveDiaryActiveView", payload);
};

const deleteDiaryActivity = (id: number) => {
    return api.delete(`/Diary/${id}`);
};

const updateDiaryActivity = (id: number, payload: any) => {
    return api.put(`/Diary/${id}`, payload);
};

const copyActivities = (payload: any) => {
    return api.post("/Diary/CopyActivities", payload);
};

export default {
    getDiaryCount,
    getDiaryActiveView,
    getAllEmployersForDiary,
    getDiaryActivitesByMemberEmployers,
    getAllWorkActivitiesForDiary,
    addDiaryActivities,
    saveDiaryActiveView,
    deleteDiaryActivity,
    updateDiaryActivity,
    copyActivities
};